import React, { useState } from 'react'; // Adicionado useState
import { X, LayoutDashboard, TrendingUp, Target, DollarSign, BarChart3, ExternalLink } from 'lucide-react';
import GraficoFaturamento from './GraficoFaturamentoAno'; // Importe o novo componente

export default function FaturamentoTotal({ data, onClose }) {
  const [showGrafico, setShowGrafico] = useState(false); // Estado para o modal do gráfico

  const formatBRL = (val) => 
    Number(val || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
      <div className="bg-[#0d1117] border border-gray-800 w-full max-w-3xl rounded-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
        
        {/* Cabeçalho */}
        <div className="flex justify-between items-center p-4 border-b border-gray-800 bg-[#161b22]">
          <div className="flex items-center gap-2 text-green-400 font-bold tracking-widest text-xs uppercase">
            <LayoutDashboard size={18} />
            <span>Detalhamento de Faturamento</span>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-white transition-colors">
            <X size={20} />
          </button>
        </div>

        {/* Conteúdo em Grid */}
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          
          <div className="bg-[#161b22] p-4 rounded border border-gray-800">
            <div className="flex justify-between mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Faturamento do Dia</p>
              <DollarSign size={14} className="text-gray-600" />
            </div>
            <p className="text-white text-2xl font-mono font-bold">
              {formatBRL(data?.valor_totalDia || 0)}
            </p>
          </div>

          <div className="bg-[#161b22] p-4 rounded border border-gray-800">
            <div className="flex justify-between mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Total Realizado (Mês)</p>
              <TrendingUp size={14} className="text-gray-500" />
            </div>
            <p className="text-gray-400 text-2xl font-mono font-bold">
              {formatBRL(data?.valor_Total || 0)}
            </p>
          </div>

          <div className="bg-[#161b22] p-4 rounded border border-gray-800">
            <div className="flex justify-between mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Maior Faturamento (Mês)</p>
              <TrendingUp size={14} className="text-green-500" />
            </div>
            <p className="text-green-400 text-2xl font-mono font-bold">
              {formatBRL(data?.valor_total_maior || 0)}
            </p>
          </div>

          <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Devoluções do Mês</p>
              <BarChart3 size={14} className="text-red-500 opacity-70" />
            </div>
            <p className="text-red-400 text-2xl font-mono font-bold tracking-tighter">
              {formatBRL(data?.valor_devolucoesMes)}
            </p>
          </div>

          {/* LINK PARA A NOVA PÁGINA DO GRÁFICO (ADICIONADO AQUI) */}
          <div className="md:col-span-2">
            <button 
              onClick={() => setShowGrafico(true)}
              className="w-full flex items-center justify-center gap-2 bg-blue-600/10 hover:bg-blue-600/20 border border-blue-500/30 text-blue-400 py-3 rounded-lg transition-all group"
            >
              <BarChart3 size={16} className="group-hover:scale-110 transition-transform" />
              <span className="text-[10px] uppercase font-black tracking-[0.2em]">Acessar Gráfico</span>
              <ExternalLink size={14} className="opacity-50" />
            </button>
          </div>

          {/* Footer de Insight */}
          <div className="md:col-span-2 bg-[#161b22] p-4 rounded border border-green-900/30 flex items-center gap-4">
            <div className="bg-green-500/10 p-3 rounded-full text-green-400">
              <Target size={24} />
            </div>
            <div>
              <p className="text-gray-400 text-[10px] uppercase font-bold">Status Comercial</p>
              <p className="text-gray-300 text-xs italic">
                {Number(data?.percentualMeta) >= 100 
                  ? "Meta mensal atingida com sucesso." 
                  : "Em andamento para atingir a meta projetada."}
              </p>
            </div>
          </div>
        </div>

        {/* Botão Fechar */}
        <div className="p-4 bg-[#0d1117] text-right border-t border-gray-800">
          <button 
            onClick={onClose}
            className="bg-gray-800 hover:bg-gray-700 text-white text-[10px] font-black py-2 px-8 rounded transition-all uppercase tracking-widest shadow-lg"
          >
            Fechar Janela
          </button>
        </div>
      </div>

      {/* Renderização condicional do modal do gráfico */}
      {showGrafico && (
        <GraficoFaturamento 
          data={data?.listaFaturamento} // Assumindo que você passará a lista de pedidos aqui
          onClose={() => setShowGrafico(false)} 
        />
      )}
    </div>
  );
}